import { FC, useEffect, useState } from 'react'
import './index.css'
import { ThemeProvider as MUIThemeProvider, createTheme } from '@mui/material'
import { ThemeProvider as SCThemeProvider } from 'styled-components'
import { RenderIf } from 'shared/helpers/renderIf'
import { PageLoader } from 'features/PageLoader'
import { AppRouter } from './appRouter'
import { MAIN_COLOR_CC, MAIN_COLOR_QRM } from 'shared/globalConsts'
import { useThemeStore } from 'shared/store/themeSlice'
import { checkIsLoggedIn } from 'shared/helpers/checkIsLoggedIn'
import { initApp } from 'shared/helpers/initApp'
import { useAuthStore } from 'shared/store/authSlice'
import { Toaster } from 'features/Toaster'

import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'

// TODO: replace with store
export let themeColor: 'light' | 'dark' = 'light'
export let selectedApp: 'qrmenu' | 'clickcollect' = 'qrmenu'

export const App: FC = () => {
  const [isLoading, setIsLoading] = useState(true)
  const isLoggedIn = useAuthStore().isLoggedIn
  const [loadInitData] = initApp(setIsLoading)
  const { themeColor } = useThemeStore()

  useEffect(() => {
    startApp()
  }, [isLoggedIn]) //eslint-disable-line

  // Functions
  const startApp = async () => {
    await loadInitData()
  }

  useEffect(() => {
    checkIsLoggedIn()
  }, [])

  const theme = createTheme({
    palette: {
      mode: themeColor,
      warning: {
        main: MAIN_COLOR_QRM
      }
    }
  })

  return (
    <>
      <MUIThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <SCThemeProvider
            theme={{
              // TODO: store in global vars
              backGroundColor: themeColor === 'dark' ? '#000' : '#fff',
              textColor: themeColor === 'dark' ? '#fff' : '#000',
              accentColor: selectedApp === 'qrmenu' ? MAIN_COLOR_QRM : MAIN_COLOR_CC
            }}
          >
            <RenderIf condition={isLoading}>
              <PageLoader isLoading={isLoading} />
            </RenderIf>
            <RenderIf condition={!isLoading}>
              <AppRouter />
            </RenderIf>
            <Toaster />
          </SCThemeProvider>
        </LocalizationProvider>
      </MUIThemeProvider>
    </>
  )
}
